import ApiService from "@/core/services/api.service";
// action types
export const PAGINATION_CAMPAIGN = "paginationCampaign";
export const GET_CAMPAIGN = "getCampaign";
export const FIND_CAMPAIGN = "findCampaign";
export const CREATE_CAMPAIGN = "createCampaign";
export const UPDATE_CAMPAIGN = "updateCampaign";
export const UPDATE_CAMPAIGN_ISACTIVE = "updateCampaignIsActive";
export const DELETE_CAMPAIGN = "deleteCampaign";
export const CREATE_CAMPAIGN_RECEIPT_REWARD = "createCampaignReceiptReward";
export const UPDATE_CAMPAIGN_RECEIPT_REWARD = "updateCampaignReceiptReward";
export const DELETE_CAMPAIGN_RECEIPT_REWARD = "deleteCampaignReceiptReward";
export const DASHBOARD_CHART_CAMPAIGN = "dashboardChartCampaign";
export const DASHBOARD_CUSTOMER_LINE_CHART_CAMPAIGN =
  "dashboardCustomerLineCampaign";
export const DASHBOARD_REG_PER_DAY_LINE_CHART_CAMPAIGN =
  "dashboardRegPerDayLineCampaign";
export const DASHBOARD_RETENTION_CUSTOMERS_CHART_CAMPAIGN =
  "dashboardRetentionCustomersChartCampaign";
export const DASHBOARD_PEAK_CHART_CAMPAIGN = "dashboardPeakChartCampaign";
export const DASHBOARD_OLD_CUSTOMERS_CHART_CAMPAIGN =
  "dashboardOldCustomersChartCampaign";
export const DASHBOARD_REG_PER_DAY_EXPORT_CAMPAIGN =
  "dashboardRegPerDayExportCampaign";
export const DASHBOARD_CUSTOMER_LINE_EXPORT_CAMPAIGN =
  "dashboardCustomerLineExportCampaign";
export const DASHBOARD_RECEIPT_TYPE_EXPORT_CAMPAIGN =
  "dashboardReceiptTypeExportCampaign";
export const DASHBOARD_UNAPPROVED_REASON_EXPORT_CAMPAIGN =
  "dashboardUnapprovedReasonExportCampaign";
export const DASHBOARD_REDEEM_REWARD_EXPORT_CAMPAIGN =
  "dashboardRedeemRewardExportCampaign";
export const DASHBOARD_RECEIPT_REWARD_POINT_EXPORT_CAMPAIGN =
  "dashboardReceiptRewardPointExportCampaign";
// segments action types
export const SEGMENTS_SUMMARY_CAMPAIGN = "segmentsSummaryCampaign";
export const SEGMENTS_ENGAGEMENT_CAMPAIGN = "segmentsEngagementCampaign";
export const SEGMENTS_RECEIPT_ACTIVITY_CAMPAIGN =
  "segmentsReceiptActivityCampaign";
export const SEGMENTS_FRAUD_MEMBERS_CAMPAIGN = "segmentsFraudMembersCampaign";
// mutation types
export const SET_PAGINATION = "setPagination";
export const SET_IS_CLEAR_PAGINATION = "setIsClearPagination";
export const CLEAR_PAGINATION = "clearPagination";

export default {
  state: {
    path: "campaign",
    isClearPagination: true,
    pagination: {
      page: 1,
      perPage: 25,
      orderBy: "id",
      isDesc: true,
      sortDirection: "asc",
      filter: ""
    }
  },
  getters: {},
  actions: {
    [PAGINATION_CAMPAIGN](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/pagination`, {
        params: payload.params
      });
    },
    [GET_CAMPAIGN](context) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}`);
    },
    [FIND_CAMPAIGN](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/${payload.id}`, null);
    },
    [CREATE_CAMPAIGN](context, payload) {
      ApiService.setHeader();
      return ApiService.post(`${context.state.path}`, payload.data);
    },
    [UPDATE_CAMPAIGN](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}/${payload.id}`,
        payload.data
      );
    },
    [UPDATE_CAMPAIGN_ISACTIVE](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}_isActive/${payload.id}`,
        payload.data
      );
    },
    [CREATE_CAMPAIGN_RECEIPT_REWARD](context, payload) {
      ApiService.setHeader();
      return ApiService.post(
        `${context.state.path}/${payload.campaign_id}/receipt_reward`,
        payload.data
      );
    },
    [UPDATE_CAMPAIGN_RECEIPT_REWARD](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}/${payload.campaign_id}/receipt_reward/${payload.reward_id}`,
        payload.data
      );
    },
    [DELETE_CAMPAIGN_RECEIPT_REWARD](context, payload) {
      ApiService.setHeader();
      return ApiService.delete(
        `${context.state.path}/${payload.campaign_id}/receipt_reward/${payload.reward_id}`
      );
    },
    [DELETE_CAMPAIGN](context, payload) {
      ApiService.setHeader();
      return ApiService.delete(`${context.state.path}/${payload.id}`);
    },
    refineOcrFilterPrompt(context, payload) {
      ApiService.setHeader();
      return ApiService.post(`${context.state.path}/refine_ocr_filter_prompt`, payload);
    },
    refineReceiptDuplicatePrompt(context, payload) {
      ApiService.setHeader();
      return ApiService.post(`${context.state.path}/refine_receipt_duplicate_prompt`, payload);
    },
    refineApprovalCriteriaPrompt(context, payload) {
      ApiService.setHeader();
      return ApiService.post(`${context.state.path}/refine_approval_criteria_prompt`, payload);
    },
    [DASHBOARD_CHART_CAMPAIGN](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(
        `${context.state.path}/dashboard/${payload.id}`,
        { params: payload.params }
      );
    },
    [DASHBOARD_PEAK_CHART_CAMPAIGN](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(
        `${context.state.path}/dashboard_peak_chart/${payload.id}`,
        { params: payload.params }
      );
    },

    [DASHBOARD_CUSTOMER_LINE_CHART_CAMPAIGN](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(
        `${context.state.path}/dashboard_customer_line_chart/${payload.id}`,
        {
          params: payload.params
        }
      );
    },
    [DASHBOARD_REG_PER_DAY_LINE_CHART_CAMPAIGN](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(
        `${context.state.path}/dashboard_reg_per_day_line_chart/${payload.id}`,
        {
          params: payload.params
        }
      );
    },
    [DASHBOARD_OLD_CUSTOMERS_CHART_CAMPAIGN](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(
        `${context.state.path}/dashboard_old_customers_chart/${payload.id}`,
        {
          params: payload.params
        }
      );
    },
    [DASHBOARD_RETENTION_CUSTOMERS_CHART_CAMPAIGN](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(
        `${context.state.path}/dashboard_retention_customers_chart/${payload.id}`,
        {
          params: payload.params
        }
      );
    },

    [DASHBOARD_REG_PER_DAY_EXPORT_CAMPAIGN](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(
        `${context.state.path}/dashboard_reg_per_day_export/${payload.id}`,
        {
          params: payload.params
        }
      );
    },
    [DASHBOARD_CUSTOMER_LINE_EXPORT_CAMPAIGN](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(
        `${context.state.path}/dashboard_customer_line_export/${payload.id}`,
        {
          params: payload.params
        }
      );
    },
    [DASHBOARD_RECEIPT_TYPE_EXPORT_CAMPAIGN](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(
        `${context.state.path}/dashboard_receipt_type_export/${payload.id}`,
        {
          params: payload.params
        }
      );
    },
    [DASHBOARD_UNAPPROVED_REASON_EXPORT_CAMPAIGN](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(
        `${context.state.path}/dashboard_unapproved_reason_export/${payload.id}`,
        {
          params: payload.params
        }
      );
    },
    [DASHBOARD_REDEEM_REWARD_EXPORT_CAMPAIGN](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(
        `${context.state.path}/dashboard_redeem_reward_export/${payload.id}`,
        {
          params: payload.params
        }
      );
    },
    [DASHBOARD_RECEIPT_REWARD_POINT_EXPORT_CAMPAIGN](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(
        `${context.state.path}/dashboard_receipt_reward_point_export/${payload.id}`,
        {
          params: payload.params
        }
      );
    },

    // ─── Segments ───────────────────────────────────────────────
    // GET /campaign/:id/segments/summary
    // Response: { status, data: { totalMembers, active, atRisk, lapsed, memberCap, insight } }
    [SEGMENTS_SUMMARY_CAMPAIGN](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(
        `${context.state.path}/${payload.id}/segments/summary`,
        { params: payload.params }
      );
    },

    // GET /campaign/:id/segments/engagement?trend_range=12w
    // Response: { status, data: { segments: [...], trendData: {...}, trendAxis: {...} } }
    [SEGMENTS_ENGAGEMENT_CAMPAIGN](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(
        `${context.state.path}/${payload.id}/segments/engagement`,
        { params: payload.params }
      );
    },

    // GET /campaign/:id/segments/receipt-activity?start_date=&end_date=
    // Response: { status, data: { receiptDistribution, receiptBreakdown, spendTiers, paretoInsight, frequencyCells, fraudFlag } }
    [SEGMENTS_RECEIPT_ACTIVITY_CAMPAIGN](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(
        `${context.state.path}/${payload.id}/segments/receipt-activity`,
        { params: payload.params }
      );
    },

    // GET /campaign/:id/segments/fraud-members?search=&page=&per_page=
    // Response: { status, data: { total, members: [{ id, name, phone, totalReceipts, rejectCount, rejectRate, segment }] } }
    [SEGMENTS_FRAUD_MEMBERS_CAMPAIGN](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(
        `${context.state.path}/${payload.id}/segments/fraud-members`,
        { params: payload.params }
      );
    }
  },
  mutations: {
    [SET_PAGINATION](state, payload) {
      state.pagination = payload.pagination;
    },
    [SET_IS_CLEAR_PAGINATION](state, payload) {
      state.isClearPagination = payload.isClearPagination;
    },
    [CLEAR_PAGINATION](state) {
      state.pagination = {
        page: 1,
        perPage: 25,
        orderBy: "id",
        isDesc: true,
        sortDirection: "asc",
        filter: ""
      };
    }
  }
};
